import React from "react";
import "./Footer.css";
// import {
//   FaFacebookF,
//   FaInstagram,
//   FaWhatsapp,
//   FaYoutube,
// } from "react-icons/fa";
import { BiSolidPhoneCall } from "react-icons/bi";
import { MdOutlineCopyright } from "react-icons/md";

const Footer = () => {
  return (
    <footer className="bg-dark text-white py-5" >
      <div className="container"data-sal="fade" data-sal-duration="1000" data-sal-delay="300">
        <div className="row text-center">
          {/* Brand */}
          <div className="col-md-3 mb-4" >
            <a href="/">
            <img
              src="assets/Images/velarimg.png"
              alt="Velar Heights"
              className="img-fluid mb-2"
              style={{ maxWidth: "250px", height: "auto" }}
            />
            </a>
            <p className="fs-5">Transforming Homes with Excellence</p>
            {/* <p className="mt-3 fs-5">Follow us on:</p>
            <div className="d-flex justify-content-center gap-3 flex-wrap">
              <a href="#" className="social-icon facebook fs-6 rounded-circle">
                <FaFacebookF />
              </a>
              <a href="#" className="social-icon instagram fs-6 rounded-circle">
                <FaInstagram />
              </a>
              <a href="#" className="social-icon whatsapp fs-6 rounded-circle">
                <FaWhatsapp />
              </a>
              <a href="#" className="social-icon youtube fs-6 rounded-circle">
                <FaYoutube />
              </a>
            </div> */}
          </div>

          {/* Quick Links */}
          <div className="col-md-3 mb-4 d-flex flex-column align-items-center">
            <h6 className="text-war fw-bold fs-5">Quick Links</h6>
            <ul className="list-unstyled fs-5 lh-lg mb-0">
              <li>
                <a href="/" className="text-white text-decoration-none">
                  Home
                </a>
              </li>
              <li>
                <a href="/about" className="text-white text-decoration-none">
                  About
                </a>
              </li>
              <li>
                <a href="/services" className="text-white text-decoration-none">
                  Services
                </a>
              </li>
              <li>
                <a href="/work-portfolio" className="text-white text-decoration-none">
                  Work Portfolio
                </a>
              </li>
              <li>
                <a href="/contact" className="text-white text-decoration-none">
                  Contact Us
                </a>
              </li>
            </ul>
          </div>

          {/* Our Services */}
          <div className="col-md-3 mb-4 d-flex flex-column align-items-center">
            <h6 className="text-war fw-bold fs-5">Our Services</h6>
            <ul className="list-unstyled fs-5 lh-lg mb-0">
              <li>
                <a href="/kitchen-renovations" className="text-white text-decoration-none">
                  Kitchen Renovations
                </a>
              </li>
              <li>
                <a href="/bathroom-renovation" className="text-white text-decoration-none">
                  Bathroom Renovations
                </a>
              </li>
              <li>
                <a href="/basement-renovation" className="text-white text-decoration-none">
                  Basement Renovations
                </a>
              </li>
              <li>
                <a href="/home-renovation" className="text-white text-decoration-none">
                  Home Extensions
                </a>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div className="col-md-3 mb-4 d-flex flex-column align-items-center">
            <h6 className="text-war fw-bold fs-5">Contact Info</h6>
            <p className="d-flex justify-content-center align-items-center gap-2 fs-5">
              <BiSolidPhoneCall className="text-war fs-5" />
              <a
                href="tel:+16472474110"
                className="text-white text-decoration-none fw-semibold"
              >
                +1 647-247-4110
              </a>
            </p>
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="text-center mt-4 text-secondary small">
       <MdOutlineCopyright/> {new Date().getFullYear()} All Rights Reserved | Velar Heights Renovation
        </div>
      </div>
    </footer>
  );
};

export default Footer;